import { Typography, Box, IconButton, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";

interface UpgradeYourPlanBannerProps {
  onClose: () => void;
  onUpgrade: () => void;
}

function UpgradeYourPlanBanner({ onClose, onUpgrade }: UpgradeYourPlanBannerProps) {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        backgroundColor: PureLightThemeCaaS.colors.alpha.orange[100],
        color: PureLightThemeCaaS.colors.alpha.white[100],
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "8px 16px",
        marginTop: "70px",
        minHeight: "70px",
        zIndex: 9999,
      }}
    >
      <Box sx={{ flex: 1, display: "flex", flexDirection: { lg: "row", md: "row", sm: "row", xs: "column" }, justifyContent: "center", alignItems: "center", textAlign: "center" }}>
        <Typography variant="h4" fontFamily="Roboto, Arial" fontWeight={500} width={{ lg: "auto", md: "auto", sm: "auto", xs: "90%" }}>
          You have used all your free requests. Please upgrade to our paid plans
        </Typography>
        <Button
          variant="text"
          onClick={onUpgrade}
          sx={{
            fontFamily: "Roboto, Arial",
            color: PureLightThemeCaaS.colors.alpha.white[100],
            justifyContent: { lg: "left", md: "left", sm: "left", xs: "center" },
            alignItems: "flex-start",
            lineHeight: 1,
            textAlign: "left",
            p: 0.5,
            pr: 0,
            textDecoration: "underline",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          here
        </Button>
      </Box>

      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: "8px",
          top: "50%",
          transform: "translateY(-50%)",
          color: PureLightThemeCaaS.colors.alpha.white[100],
        }}
      >
        <CloseIcon />
      </IconButton>
    </Box>
  );
}

export default UpgradeYourPlanBanner;
